import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useEffect } from "react";

const Refund = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="container mx-auto px-4 py-24 max-w-4xl">
        <h1 className="font-display text-4xl md:text-5xl font-bold mb-8 text-center">
          Refund <span className="text-gradient">Policy</span>
        </h1>
        
        <div className="space-y-8 text-muted-foreground">
          <section className="bg-card/50 p-8 rounded-2xl border border-border/50 backdrop-blur-sm">
            <h2 className="font-display text-2xl font-semibold text-foreground mb-4">REFUND / RE-BOOKINGS</h2>
            <p>
              Tickets that are refunded may incur a 50% penalty fee. Rebooking a ticket must be requested 24 hours before departure / earlier and will only be allowed once per ticket. When re-booking a ticket, a penalty fee may be applied and cannot be refunded. No refund / re-booking will be allowed 2 hours prior or after the scheduled departure time.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Refund;
